import ChecklistReportItemComponent, {
  ChecklistReportItemComponentProps,
} from './ChecklistReportItemComponent';

export default ChecklistReportItemComponent;

export type { ChecklistReportItemComponentProps };
